import request from "@/utils/request";

//销售市场查询
export function SaleNewWorks(query) {
  return request({
    url: "/userInfo/saleNewWorks",
    method: "get",
    params: query,
  });
}

//服务市场查询
export function miMemberRights(query) {
  return request({
    url: "/userInfo/miMemberRights",
    method: "get",
    params: query,
  });
}

//服务市场查询 结构
export function miMemberRightsStructure(query) {
  return request({
    url: "/userInfo/miMemberRightsStructure",
    method: "get",
    params: query,
  });
}

//服务市场查询 业绩
export function miMemberRightsSell(query) {
  return request({
    url: "/userInfo/miMemberRightsSell",
    method: "get",
    params: query,
  });
}

//经销商资料维护
export function memberInfoEdit(data) {
  return request({
    url: "/userInfo/memberInfoEdit",
    method: "post",
    data,
  });
}

//更改密码
export function modifyPwd(data) {
  return request({
    url: "/userInfo/modifyPwd",
    method: "post",
    data,
  });
}

//佣金查询
export function bdBonusHisMemChinas(query) {
  return request({
    url: "/userInfo/bdBonusHisMemChinas",
    method: "get",
    params: query,
  });
}

//佣金预测
export function bdPreHisMems(query) {
  return request({
    url: "/userInfo/bdPreHisMems",
    method: "get",
    params: query,
  });
}

//经销商业绩
export function bdBonusMemberSellChinas(query) {
  return request({
    url: "/userInfo/bdBonusMemberSellChinas",
    method: "get",
    params: query,
  });
}

//实时业绩

export function bdBonusRealTimes(query) {
  return request({
    url: "/userInfo/bdBonusRealTimes",
    method: "get",
    params: query,
  });
}

// 个人信息查询
export function personAllInfo(query) {
  return request({
    url: "/userInfo/personAllInfo",
    method: "GET",
    params: query,
  });
}

// 查询高级点位
export function listCardThumbnail(query) {
  return request({
    url: "/memberRight/listCardThumbnail",
    method: "GET",
    params: query,
  });
}
// 查询高级点位 查看
export function getMiNetnum(query) {
  return request({
    url: "/memberRight/getMiNetnum",
    method: "GET",
    params: query,
  });
}

// 经销商卡片
export function memberCard(query) {
  return request({
    url: "/userInfo/memberCard",
    method: "GET",
    params: query,
  });
}
